import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    questionnaires: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_QUESTIONNAIRE_SELECT_IDS (store, ids) {
      store.questionnaires.selectIds = ids
    },
    REMOVE_QUESTIONNAIRE_SELECT_IDS (store, ids) {
      store.questionnaires.selectIds = store.questionnaires.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_QUESTIONNAIRE_SELECT_ID (store, id) {
      store.questionnaires.selectId = id
    },
    SET_QUESTIONNAIRE_FILTERS (store, filters) {
      store.questionnaires.filters = filters
    },
    SET_QUESTIONNAIRE_PAGINATE (store, val) {
      store.questionnaires.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getQuestionnaires: (store, getters) => {
      return store.questionnaires.selectIds.map((id) => {
        return getters['entities/questionnaires/find'](id)
      })
    },
    getQuestionnairesFilters: (store, getters) => {
      return store.questionnaires.filters
    },
    getQuestionnairesPaginate: (store, getters) => {
      return store.questionnaires.paginate
    },
    getQuestionnaire: (store, getters) => {
      return getters['entities/questionnaires/find'](store.questionnaires.selectId) || {}
    }
  },
  actions: {
    /*
    selectQuestionnaires
    */
    selectQuestionnaires ({commit, dispatch, getters, state}, filters) {
      return dispatch('getQuestionnaires', filters)
      .then((response) => {
        commit('SET_QUESTIONNAIRE_FILTERS', filters)
        commit('SET_QUESTIONNAIRE_PAGINATE', response)
        commit('SET_QUESTIONNAIRE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectQuestionnaires
    */
    refreshSelectQuestionnaires ({commit, dispatch, getters, state}) {
      return dispatch('selectQuestionnaires', getters.getQuestionnairesFilters)
    },
    /*
    selectQuestionnaire
    */
    selectQuestionnaire ({commit, dispatch, getters, state}, id) {
      return dispatch('getQuestionnaireById', id)
      .then((response) => {
        commit('SET_QUESTIONNAIRE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getQuestionnaires
    */
    getQuestionnaires ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/questionnaires`, {params: filters})
      .then((response) => {
        return dispatch('entities/questionnaires/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.questionnaires || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getQuestionnaireById
    */
    getQuestionnaireById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/questionnaires/${id}`)
      .then((response) => {
        return dispatch('entities/questionnaires/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.questionnaires[0]
      })
    },
    /*
    createQuestionnaire
    */
    createQuestionnaire ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/questionnaires`, data)
      .then((response) => {
        return dispatch('entities/questionnaires/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.questionnaires[0]
      })
    },
    /*
    updateQuestionnaire
    */
    updateQuestionnaire ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/questionnaires/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/questionnaires/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.questionnaires[0]
      })
    },
    /*
    deleteQuestionnaire
    */
    deleteQuestionnaire ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/questionnaires/${id}`)
      .then((response) => {
        commit('REMOVE_QUESTIONNAIRE_SELECT_IDS', [id])
        dispatch('entities/questionnaires/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Questionnaire.js